import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../components/Layout";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";

const Insiders = () => {
  const navigate = useNavigate();
  const addNewInsiders = {
    id: "addnewpost",
    onClick: () => navigate("/insiders/add-insider"),
    style: { width: "240px" },
    label: "Add New Insiders",
  };
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);
  const [loader,setLoader]=useState(true)
  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}insiders/list`,
      initialParams: {
        sort,
        // search: category,
        // selectedValues,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("insiders", fetchData, setShowDelete);

  useEffect(() => {
    setLoader(true)
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Name of Insiders",
      dataIndex: "name",
      fixed: "left",
      key: "name",
    },
    { title: "Designation", dataIndex: "designation", key: "designation" },
    { title: "LinkedIn Profile", dataIndex: "linkedin", key: "linkedin" },
    {
      title: "Profile Image",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (image) => (
        <img
          src={image}
          style={{ width: "100px", height: "100px", borderRadius: "5px" }}
          alt="insider"
        />
      ),
    },
    { title: "Upload Time", dataIndex: "uploadTime", key: "uploadTime" },

    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isEdit={true}
          isDelete={true}
          onClickDelete={() => {
            setDeleteId(record.key);
            setShowDelete(true);
          }}
          onClickEdit={() => navigate(`/insiders/${record.key}/edit-insider`)}
        />
      ),
    },
  ];

  const dataSource = records.map((el, i) => ({
    key: el._id,
    serial: i + 1,
    name: el.name,
    designation: el.designation,
    linkedin: el.linkedin,
    profileImage: el.insiderImage,
    uploadTime: moment(el.createdAt).format("DD MMMM YYYY LT"),
    actions: el._id,
  }));

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Settings",
        link: "/settings-social-media-link",
      },
      { text: "Add Social Media Links", link: "" },
    ],
    [],
  );

  useEffect(()=>{
    records && setTimeout(()=>setLoader(false))
  },[records])

  return (
    <ListPageLayout
      breadcrumbs={
        <Breadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewInsiders} />}
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
      }}
      loader={loader}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
    >
      {/* Optional children like modals */}
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default Insiders;
